import { render, staticRenderFns } from "./Ptspprovinsi.vue?vue&type=template&id=4bf7c32e"
import script from "./Ptspprovinsi.vue?vue&type=script&lang=js"
export * from "./Ptspprovinsi.vue?vue&type=script&lang=js"
import style0 from "./Ptspprovinsi.vue?vue&type=style&index=0&id=4bf7c32e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports